import { translate } from "../Services/translation";
import { MAP_STYLES } from "./Dealer.Map.Styles";
import map_marker from "../../images/blackmarker.svg";
import user_map_marker from "../../images/redmarker.svg";

let map;
let userMarker;

const getListWithMarkers = (dealerList) => {
  // Copy of dealerList in order to mutate
  const listWithMarkers = dealerList.slice();

  // Adding dealer-pins to map
  dealerList.forEach((dealer, index) => {
    try {
      if (dealer.Coordinates) {
        // Formats/splits coordinates
        const [lat, lng] = dealer.Coordinates.split(", ");
        const latLng = new google.maps.LatLng(lat, lng);

        const icon = {
          url: map_marker,
          anchor: new google.maps.Point(16, 32),
          scaledSize: new google.maps.Size(32, 32),
        };

        const marker = new google.maps.Marker({
          position: latLng,
          icon: icon,
          location: latLng,
        });

        // Info-window when clicking on marker
        const contentString =
          `<b>${dealer.CompanyName}</b>` +
          `<div>${dealer.StreetAdress}</div>` +
          `<div>${dealer.ZipCode + " " + dealer.City}</div>` +
          `<a href=https://www.google.com/maps/dir/?api=1&destination=${dealer.Coordinates.replace(
            / /g,
            ""
          )} target="_blank" style="text-decoration: underline; color: #0000EE;">${translate(
            "dealers.find-us"
          )}</a>`;

        const infowindow = new google.maps.InfoWindow({
          content: contentString,
          ariaLabel: dealer.CompanyName,
        });

        marker.addListener("click", () => {
          infowindow.open({
            anchor: marker,
            map,
          });
        });

        listWithMarkers[index].Marker = marker;
      }
    } catch (error) {
      console.error(`Error in iteration ${index}: ${error.message}`);
      return;
    }
  });
  return listWithMarkers;
};

const fitMapToMarkers = (dealerList) => {
  const bounds = new google.maps.LatLngBounds();

  dealerList.forEach(({ Marker }) => {
    bounds.extend(Marker.getPosition());
  });

  if (userMarker) {
    bounds.extend(userMarker.getPosition());
  }

  map.fitBounds(bounds);
};

export const updateMap = (dealerList, filteredDealerList) => {
  dealerList.forEach(({ Marker }) => {
    Marker.setMap(null);
  });

  filteredDealerList.forEach(({ Marker }) => {
    Marker.setMap(map);
  });
  if (filteredDealerList.length != 0) {
    fitMapToMarkers(filteredDealerList);
  }
};

export const initMap = async (
  dealerList,
  defaultLocation,
  setLocation,
  setIsLoaded,
  setDealerList
) => {
  const { Map } = await google.maps.importLibrary("maps");
  const { Place } = await google.maps.importLibrary("places");
  const { Geometry } = await google.maps.importLibrary("geometry");
  const input = document.getElementById("pac-input");
  const inputButton = document.getElementById("pac-input-button");
  const autocompleteOptions = {
    fields: ["address_components", "geometry", "icon", "name"],
    strictBounds: false,
  };
  const autocomplete = new google.maps.places.Autocomplete(
    input,
    autocompleteOptions
  );

  setIsLoaded(true);

  const defaultLatLng = new google.maps.LatLng(
    defaultLocation.Latitude,
    defaultLocation.Longitude
  );

  map = new Map(document.getElementById("map"), {
    center: defaultLatLng,
    zoom: 4.5,
    disableDefaultUI: true,
    zoomControl: true,
    styles: MAP_STYLES,
    maxZoom: 15,
  });

  const listWithMarkers = getListWithMarkers(dealerList);

  listWithMarkers.forEach(({ Marker }) => {
    Marker.setMap(map);
  });
  setDealerList(listWithMarkers);

  const getUserLocation = () => {
    const place = autocomplete.getPlace();

    const icon = {
      url: user_map_marker,
      anchor: new google.maps.Point(16, 32),
      scaledSize: new google.maps.Size(32, 32),
    };

    if (userMarker) {
      userMarker.setMap(null);
    }
    userMarker = new google.maps.Marker({
      map,
      anchorPoint: new google.maps.Point(0, -29),
      icon,
    });
    userMarker.setVisible(false);

    if (!place.geometry || !place.geometry.location) {
      getUserLocationByString(place.name);
      return;
    }

    setLocation(place.name);

    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(17);
    }

    userMarker.setPosition(place.geometry.location);
    userMarker.setVisible(true);
  };

  const getUserLocationByString = async (name) => {
    const service = new google.maps.places.PlacesService(map);

    const request = {
      query: name,
      fields: ["name", "geometry"],
    };

    service.findPlaceFromQuery(request, function (results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        const place = results[0];

        input.value = place.name;
        setLocation(place.name);

        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(17);
        }

        userMarker.setPosition(place.geometry.location);
        userMarker.setVisible(true);
      } else {
        alert("dealers.no-results");
      }
    });
  };

  autocomplete.addListener("place_changed", () => {
    getUserLocation();
  });

  inputButton.addEventListener("click", function () {
    if (input.value) {
      getUserLocationByString(input.value);
    }
  });

  fitMapToMarkers(listWithMarkers);
};

export const clearUserMarker = (dealerList) => {
  userMarker.setVisible(false);

  if (dealerList && dealerList.length != 0) {
    fitMapToMarkers(dealerList);
  }
};

export const calculateDistances = (dealersList, setDealerList, setIsLoading) => {
  const service = new google.maps.DistanceMatrixService();
  const maxRequests = 24;
  const amountOfRequests = Math.ceil(dealersList.length / maxRequests);
  const listWithDistances = [];
  let requestCheck = 0;

  setIsLoading(true);

  for (let i = 0; i < dealersList.length / maxRequests; i++) {
    let pageSize = maxRequests;
    if (i * maxRequests + maxRequests > dealersList.length) {
      pageSize = dealersList.length % (i * maxRequests);
    }

    const from = i * maxRequests;
    const to = from + pageSize;

    const slicedList = dealersList.slice(from, to);

    service.getDistanceMatrix(
      {
        origins: [userMarker.position],
        destinations: slicedList.map(({ Marker }) => Marker.location),
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response, status) => distanceCallback(response, status)
    );

    const distanceCallback = (response, status) => {
      requestCheck++;
      if (status == google.maps.DistanceMatrixStatus.OK) {
        const from = i * maxRequests;
        const to = from + pageSize;
        const slicedList = dealersList.slice(from, to);
        const listOfDistances = response.rows[0].elements;

        listWithDistances.push(
          ...slicedList.map((dealer, index) => ({
            ...dealer,
            Distance: listOfDistances[index].distance,
          }))
        );

        if (requestCheck >= amountOfRequests) {
          setDealerList(
            listWithDistances.sort(
              (dealerA, dealerB) =>
                dealerA.Distance.value - dealerB.Distance.value
            )
          );

          setIsLoading(false);
        }
      }
    };
  }
};

export const clearDistances = (dealerList, setDealerList) => {
  const listWithClearedDistance = dealerList
    .map((dealer) => ({ ...dealer, Distance: "" }))
    .sort((dealerA, dealerB) =>
      dealerA.CompanyName.localeCompare(dealerB.CompanyName)
    );

  setDealerList(listWithClearedDistance);
};
